import { Field } from '@campfire/field';
import { TabletButton } from '@campfire/tablet-button';
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from '@material-ui/core';
import { Form, Formik, useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import { useAdminConsoleActions } from '../../admin-console-actions';
import {
  APPLICATION_QUESTION_TYPE_FREE_TEXT,
  ApplicationQuestionsFormValues,
  validationSchema,
} from './application-questions-model';

type Props = {
  open: boolean;
  onClose: () => void;
  refetchQuestions?: () => void;
};

export const AddApplicationQuestionDialog = ({ open, onClose, refetchQuestions }: Props) => {
  const formik = useFormikContext<ApplicationQuestionsFormValues>();
  const { applicationQuestions } = formik.values;

  const { runSaveActivityApplicationQuestions, runSaveActivityApplicationQuestionsLoading } = useAdminConsoleActions();

  const handleSuccess = () => {
    onClose();
    if (refetchQuestions) refetchQuestions();
  };

  const nextOrder = useMemo(() => {
    return applicationQuestions.reduce((previous, current) => {
      return previous > current.order ? previous : current.order;
    }, 0);
  }, [applicationQuestions]);

  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Grid item container xs={12} direction='column'>
          <Typography display='inline' variant='h6'>
            New Application Question
          </Typography>
        </Grid>
      </DialogTitle>

      <Formik
        initialValues={{
          activityApplicationQuestionId: undefined,
          label: '',
          type: APPLICATION_QUESTION_TYPE_FREE_TEXT,
          required: false,
          order: nextOrder,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          runSaveActivityApplicationQuestions({
            questions: [values, ...applicationQuestions],
            handleSuccess,
          });
        }}
      >
        {(addFormik) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2} direction='column'>
                <Grid item xs={12}>
                  <Field required autoFocus name='label' label='Question' variant='outlined' fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        color='primary'
                        checked={addFormik.values.required}
                        onChange={(e) => addFormik.setFieldValue('required', e.target.checked)}
                      />
                    }
                    label='Require an answer'
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <TabletButton variant='text' onClick={() => onClose()}>
                {'Cancel'}
              </TabletButton>
              <TabletButton variant='contained' color='primary' type='submit'>
                {runSaveActivityApplicationQuestionsLoading ? <CircularProgress size={20} /> : 'Add Question'}
              </TabletButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
